































































































































































import {Component, Prop} from 'vue-property-decorator';
import Form, { Send } from '@/components/form-base';
import { DialogForm, FormOverlay} from '@/components/bwaff';
import ApiServices from '@/services';
import api, { SecuritylApi } from '@/views/settings/security/api';
import HeaderButtons from '@/components/ui/ui-modal/modal/header-buttons.vue'

@Component({
  components: {
    FormOverlay,
    DialogForm,
    HeaderButtons
  }
})
export default class EnableDialog extends Form {
  api: SecuritylApi = api;

  step: number = 1;
  edit: boolean = true;
  loading: boolean = false;
  saved: boolean = false;
  show_password: boolean = false;
  form: any = {};
  codeList: object = {backupCodes: {}};

  //TODO: добавить перевод в базовый класс, убедившись, что ничего не сломает
  getError(input: string):  any[] {
    let errors = this.pGetError(input);

    return errors
      ? errors.map((error: any) => this.t(error))
      : [];
  }

  handleDone() {
    this.$store.commit('secondFactorAuth', true);

    ApiServices.getUserProfile().then()
    .finally(() => {
      this.close();
    });
  }

  close() {
    this.$emit('close');
  }

  @Send()
  submit() {
    return this.step == 1
      ? this.api.postTwoFactorGetQrCode(this.form).then(() => {
        this.codeList = this.api.codeList.backupCodes;
        this.step = 2;
      })
      : this.api.postTwoFactorVerifyQrCode(this.form).then((payload: any) => {
          if (payload.isTokenValid === false) {
            this.$nextTick(() => {
              this.state = {
                ...this.state,
                error: true,
                loading: false,
                'token:error': this.t('Invalid code')
              };
            });

            return Promise.reject(null);
          } else {
            this.step = 3;
            //this.$store.commit('secondFactorAuth', true);
            //ApiServices.getUserProfile().then(() => {});
          }
        });
  }
}
